import { useEffect } from "react";
import { useToastStore } from "../../store/toast.js";

/** A reward or a notice, for three seconds, over the top of the screen. */
export function Toast(): JSX.Element | null {
  const text = useToastStore((s) => s.text);
  const seq = useToastStore((s) => s.seq);
  const clear = useToastStore((s) => s.clear);
  useEffect(() => {
    if (!text) return;
    const timer = setTimeout(clear, 3200);
    return () => clearTimeout(timer);
  }, [text, seq, clear]);
  if (!text) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-16 z-50 flex justify-center px-4" role="status">
      <p
        className="rounded-full border border-gold/70 bg-bg-raised/95 px-4 py-2 text-sm font-semibold text-gold shadow-lg"
        data-testid="toast"
      >
        {text}
      </p>
    </div>
  );
}
